import { useMemo } from "react"
import { matchPath, useLocation } from "react-router"
import { abstractRoutePaths, routePaths } from "../Routes"
import { JobsDetailRouteParams } from "../Routes/Paths/Dashboard/JobDetailRoute"

export const useTaskDetailsPaths = (): [
    boolean,
    (
        orgUsername: string,
        appID: string,
        jobID: string,
        version: string,
        taskID: string,
        params?: JobsDetailRouteParams,
        selected?: number[]
    ) => string
] => {
    const location = useLocation()

    return useMemo(() => {
        const isMessagesRoute =
            matchPath(location.pathname, {
                path: abstractRoutePaths.jobsMessageDetail
            }) !== null ||
            matchPath(location.pathname, {
                path: abstractRoutePaths.appDetailMessages
            }) !== null

        return [
            isMessagesRoute,
            isMessagesRoute
                ? routePaths.taskDetailsMessages
                : routePaths.taskDetails
        ]
    }, [location.pathname])
}
